document.addEventListener("DOMContentLoaded", function () {
    const checkboxContainer = document.querySelectorAll('.checkbox-container');

    if (checkboxContainer.length > 0) {
        checkboxContainer.forEach(container => {
            const checkboxToggler = container.querySelector('.checkbox__dropdown--toggler');

            checkboxToggler.addEventListener('click', (e) => {
                e.preventDefault();
                checkboxContainer.forEach(el => {
                    if (el !== container) {
                        el.classList.remove('active');
                    }
                });
                container.classList.toggle('active');
            })
        })
    }
    const filterForm = document.getElementById('filter-voyages-form');

    if (filterForm) {
        filterForm.addEventListener('submit', function (e) {
            e.preventDefault();
            const formData = new FormData(filterForm);
            const params = new URLSearchParams();

            // Group values by name
            const groupedData = {};
            for (const [key, value] of formData.entries()) {
                if (!groupedData[key]) {
                    groupedData[key] = [];
                }
                groupedData[key].push(value);
            }

            // Construct query string
            for (const key in groupedData) {
                params.append(key, groupedData[key].join(','));
            }

            // Redirect
            window.location.href = filterForm.action.split('?')[0] + '?' + params.toString();
        });
    }
})
